<template>
  <div class="week-graph-day">
    <p>{{ number }}</p>
    
    <div class="week-graph-day--day">
      <div class="week-graph-day--day--spacing"></div>

      <div
        class="week-graph-day--day--line" 
        :style="`height: ${percentage}%;`"
      ></div>
    </div>
    
    <p>{{ day }}</p>
  </div>
</template>

<script>
  export default {
    name: 'WeekGraphDay',
    props: [
      'day',
      'number',
      'percentage'
    ]
  }
</script>

<style lang="scss">

  .week-graph-day {
    display: flex;
    flex-direction: column;
    width: 14.28%;
    padding: 7.5px;

    p {
      text-align: center;
      font-size: 13px;
    }

    &--day {
      height: 100%;
      display: flex;
      flex-direction: column;

      &--spacing {
        flex-grow: 1;
        width: 100%;
        border-radius: 3px;
        background-color: var(--blue-light);
      }

      &--line {
        background-color: var(--blue);
        border-radius: 3px;
        height: 0%;
      }      
    }
  }
</style>
